import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { SimilarInquiryMappedInterface } from 'base';
import { BaseCustomerSimilarInquiriesMdScrollService } from '../../../../_services/base-customer-similar-inquiries-md-scroll.service';

/**
 * Bottom panel of the mobile shift plan. Collapsed it leaves a strip pinned to the foot of the
 * viewport; expanded it slides up over the organizer — page-on-page rather than a modal, so it
 * carries no backdrop and the calendar header stays visible above it. The collapsed geometry
 * lives in global-scss/applications/modules/_inquiries-md.scss.
 */
@Component({
  selector: 'base-customer-similar-inquiries-md',
  templateUrl: './base-customer-similar-inquiries-md.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Scoped here so the calendar and the inquiry columns below share one offset.
  providers: [BaseCustomerSimilarInquiriesMdScrollService],
})
export class BaseCustomerSimilarInquiriesMdComponent {
  /** Loaded and mapped by base-customer-shift-plan, shared with the desktop layout's list. */
  @Input() similarInquiries: SimilarInquiryMappedInterface[] = [];

  @HostBinding('class.expanded') isExpanded = false;

  /** Null while collapsed, so the stylesheet's collapsed offset applies rather than an inline copy of it. */
  @HostBinding('style.top') top: string | null = null;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('window:resize')
  onResize(): void {
    this.applyTop();
  }

  toggle(): void {
    this.isExpanded = !this.isExpanded;
    this.applyTop();
  }

  trackByInquiry(_: number, item: SimilarInquiryMappedInterface): number | undefined {
    return item.data.id;
  }

  /**
   * Expanded, the panel stops flush under the organizer's header row. That row's viewport offset
   * depends on the page chrome stacked above it, which no CSS length can name, so it is measured
   * off the sibling. Falls back to the collapsed offset if the organizer is not rendered.
   */
  private applyTop(): void {
    if (!this.isExpanded) {
      this.top = null;

      return;
    }

    const organizerHeader = this.elementRef.nativeElement.parentElement?.querySelector('.organizer-top');

    this.top = organizerHeader ? `${organizerHeader.getBoundingClientRect().bottom}px` : null;
  }
}
